module.exports = __webpack_public_path__ + "static/media/app-badge-google-play-small.29bf829a.svg";